module.exports = __webpack_public_path__ + "img/qwwlwkxsjfw_banner.a18cb988.png";